/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { ServiceDTO } from './service-dto.model';

export class CustomerProfileDTO extends JSONable {
  uuid: string | undefined = undefined;
  customerUuid: string | undefined = undefined;
  version: number | undefined = undefined;
  lastShipmentDate: string | undefined = undefined;
  customerNeedValue: string | undefined = undefined;
  revenueBrandValue: string | undefined = undefined;
  grossProfitBrandValue: string | undefined = undefined;
  salesChannelValue: string | undefined = undefined;
  commodity: string | undefined = undefined;
  totalPotentialRevenue: number | undefined = undefined;
  totalPotentialGP: number | undefined = undefined;
  services: ServiceDTO[] | undefined = undefined;
  totalGrossProfit: number | undefined = undefined;
  totalRevenue: number | undefined = undefined;

  constructor() {
    super();
    this.services = [];
  }
}
